import React, { useState } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormInput,
  CFormLabel,
  CLoadingButton,
  CForm,
  CFormFeedback,
  CInputGroup,
  CFormSelect,
  CInputGroupText,
} from '@coreui/react-pro'
import { useFormik } from 'formik'
import ToastComponent from 'src/components/common/TaostComponent'
import ClubService from 'src/service/ClubService'
import SponsorService from 'src/service/SponsorService'
import { useMemo } from 'react'
import ReactQuill from 'react-quill'
import { useRef } from 'react'
import { useEffect } from 'react'
const GamePassFeeInfo = (props) => {
  const [loading, setLoading] = useState(false)
  const formik = useFormik({
    initialValues: {
      entry_price: props.gameDetail?.entry_price,
      isCollect: props.isCollect,
      entry_price_symbol: props.gameDetail?.entry_price_symbol,
    },
    enableReinitialize: true,
    // validationSchema,
    onSubmit: (data) => {
      data.gameId = props.gameDetail?.id
      data.entry_fee_info = props.entryFeeInfo
      data.collect_game_pass = props.isCollect
      data.is_paid_require = props.isPaidRequire
      setLoading(true)
      ClubService.updateFeeInfo(data)
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
            setLoading(false)
          } else {
            setLoading(false)
            ToastComponent(res.message, 'error')
          }
        })
        .catch((e) => {
          ToastComponent('Something went wrong.', 'error')
          setLoading(false)
        })
    },
  })

  // Editor code here.
  const quillRef = useRef()
  const imageHandler = (e) => {
    const editor = quillRef.current.getEditor()
    const input = document.createElement('input')
    input.setAttribute('type', 'file')
    input.setAttribute('accept', 'image/*')
    input.click()

    input.onchange = async () => {
      const file = input.files[0]
      if (/^image\//.test(file.type)) {
        const formData = new FormData()
        formData.append('image', file)
        const res = await SponsorService.imageUplaod(formData) // upload data into server or aws or cloudinary
        const url = res?.url
        editor.insertEmbed(editor.getSelection(), 'image', url)
      } else {
        ToastComponent('You could only upload images.', 'error')
      }
    }
  }
  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
          ['image', 'link'],
          [
            {
              color: [
                '#000000',
                '#e60000',
                '#ff9900',
                '#ffff00',
                '#008a00',
                '#0066cc',
                '#9933ff',
                '#ffffff',
                '#facccc',
                '#ffebcc',
                '#ffffcc',
                '#cce8cc',
                '#cce0f5',
                '#ebd6ff',
                '#bbbbbb',
                '#f06666',
                '#ffc266',
                '#ffff66',
                '#66b966',
                '#66a3e0',
                '#c285ff',
                '#888888',
                '#a10000',
                '#b26b00',
                '#b2b200',
                '#006100',
                '#0047b2',
                '#6b24b2',
                '#444444',
                '#5c0000',
                '#663d00',
                '#666600',
                '#003700',
                '#002966',
                '#3d1466',
              ],
            },
          ],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    [],
  )
  // Finish here

  return (
    <CForm className="row g-3" onSubmit={formik.handleSubmit}>
      <CCol md={12}>
        <CFormLabel className="fw-bold" htmlFor="Entry Fee">
          Entry Fee
        </CFormLabel>
        <CInputGroup className="mb-3">
          <CInputGroupText className="basic-addon2">
            {' '}
            <select
              aria-label="Select symbol"
              name="entry_price_symbol"
              value={formik.values.entry_price_symbol}
              onChange={formik.handleChange}
              id="entry_price_symbol"
            >
              <option value="€">EURO (€) </option>
              <option value="$">DOLLAR ($)</option>
              <option value="£">POUND (£)</option>
              <option value="">NONE</option>
            </select>
          </CInputGroupText>
          <CFormInput
            placeholder="Entry Price"
            className={
              'form-control' +
              (formik.errors.entry_price && formik.touched.entry_price ? ' is-invalid' : '')
            }
            defaultValue={formik.values.entry_price}
            onChange={formik.handleChange}
            aria-label="entry_price"
            id="entry_price"
          />
        </CInputGroup>

        {formik.errors.entry_price && formik.touched.entry_price && (
          <CFormFeedback invalid>{formik.errors.entry_price}</CFormFeedback>
        )}
      </CCol>
      <CCol md={12}>
        <CFormLabel className="fw-bold" htmlFor="Entry Fee Info">
          Entry Fee Information
        </CFormLabel>
        <ReactQuill
          theme="snow"
          ref={quillRef}
          value={props.entryFeeInfo}
          onChange={props.setEntryFeeInfo}
          modules={modules}
          // style={{ border: '1px solid' }}
        />
      </CCol>
      <CCol md={6}>
        <CLoadingButton type="submit" color="success" variant="outline" loading={loading}>
          Submit
        </CLoadingButton>
      </CCol>
    </CForm>
  )
}

export default GamePassFeeInfo
